import React, { useEffect, useState } from "react";
import {
  FaCar,
  FaTools,
  FaWrench,
  FaArrowsAltH,
  FaBalanceScale,
  FaTachometerAlt,
  FaCarBattery,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const ChoseServices = ({ selectedService }) => {
  const [service, setService] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (selectedService === "Services") {
      setService([
        {
          name: "Interim service",
          duration: "1 Hour (est)",
          icon: <FaCar size={40} color="#D74F1C" />,
        },
        {
          name: "Major service",
          duration: "2 Hours (est)",
          icon: <FaTools size={40} color="#D74F1C" />,
        },
      ]);
    } else if (selectedService === "Mobile tyre fitting service") {
      setService([
        {
          name: "New Tyre",
          duration: "1 Hour (est)",
          icon: <FaCar size={40} color="#D74F1C" />,
        },
        {
          name: "Part Worn Tyres",
          duration: "2 Hours (est)",
          icon: <FaWrench size={40} color="#D74F1C" />,
        },
        {
          name: "Wheel Alignment",
          duration: "2 Hours (est)",
          icon: <FaArrowsAltH size={40} color="#D74F1C" />,
        },
        {
          name: "Wheel Balancing",
          duration: "1 Hours (est)",
          icon: <FaBalanceScale size={40} color="#D74F1C" />,
        },
        {
          name: "Tyre Pressure Check",
          duration: "1 Hours (est)",
          icon: <FaTachometerAlt size={40} color="#D74F1C" />,
        },
      ]);
    } else if (selectedService === "Battery service") {
      setService([
        {
          name: "Battery Replacement",
          duration: "1 Hour (est)",
          icon: <FaCarBattery size={40} color="#D74F1C" />,
        },
      ]);
    } else {
      setService([
        {
          name: selectedService,
          duration: "1 Hour (est)",
          icon: <FaCar size={40} color="#D74F1C" />,
        },
      ]);
    }
  }, [selectedService]);

  return (
    <div className="service-area-1 space overflow-hidden">
      <div className="container">
        {selectedService && (
          <div className="selected-service-info text-center mb-4">
            <h3>You have selected: {selectedService}</h3>
            <p>Here are some services related to your selection</p>
          </div>
        )}
        <div className="row gy-4 justify-content-center">
          {service.map((item, index) => (
            <div className="col-lg-3 col-md-6" key={index}>
              <div className="service-card text-center">
                <div className="service-card_content">
                  <div className="my-2">{item.icon}</div>
                  <p className="text-white">{item.duration}</p>
                  <h4 className="service-card_title text-white h5">
                    {item.name}
                  </h4>
                  <button
                    onClick={() => navigate(`/booking/${item.name}`)}
                    className="btn btn-sm mt-3"
                    style={{
                      backgroundColor: "#D74F1C",
                      color: "black",
                      border: "none",
                      borderRadius: "5px",
                      padding: "10px 20px",
                      fontSize: "16px",
                      fontWeight: "bold",
                    }}
                  >
                    Book Appointment
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ChoseServices;
